import { render, staticRenderFns } from "./NotificationType.vue?vue&type=template&id=5d56c54a&"
import script from "./NotificationType.vue?vue&type=script&lang=js&"
export * from "./NotificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports